export default __webpack_public_path__ + "static/media/4.3e103108.jpg";